import React from 'react';
import { Button } from '@ok/okd';
import { toLocale } from '@common/i18n';
import { PAGE_PATH } from '../../common/context';

import './index.less';

export default ({ title }) => {
  const { cdnBaseUrl } = window.okGlobal;
  return (
    <div className="staking-content">
      <div className="staking-title">{title}</div>
      <div className="staking-box">
        <div className="staking-info">
          <img
            src={`${cdnBaseUrl}/cdn/assets/imgs/currencyInfo/staking.png`}
            alt="staking icon"
          />
          <div>
            <div>{toLocale('currency_staking_content1')}</div>
            <div>{toLocale('currency_staking_content2')}</div>
          </div>
        </div>
        <Button
          category={Button.CATEGORY.outline}
          type={Button.TYPE.primary}
          size={Button.SIZE.xs}
          href={PAGE_PATH.STAKING}
          onClick={() => {
            window.seoMonitor.act('web_token_information_staking_button_click');
          }}
        >
          {toLocale('currency_go_apply')}
        </Button>
      </div>
    </div>
  );
};
